import focusRing from '../../theme/focus';

const answerControlSx = {
  color: 'text.secondary',
  '&:focus-visible': {
    boxShadow: focusRing,
  },
};

export default answerControlSx;
